import script from "./AlertMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMsg.vue?vue&type=script&setup=true&lang=js"

import "./AlertMsg.vue?vue&type=style&index=0&id=2cc1ff52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc1ff52"]])

export default __exports__